(() => {
  'use strict';

  const STORAGE = {
    visitor: 'goat_toys_visitor_v3',
    votes: 'goat_toys_votes_v3',
    writeIns: 'goat_toys_writeins_v3'
  };

  const readJSON = (key, fallback) => {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return value == null ? fallback : value;
    } catch (_) {
      return fallback;
    }
  };

  const writeJSON = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* storage can be blocked */ }
  };

  const escapeHTML = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const slugify = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 64);

  const makeVisitorId = () => {
    let id = localStorage.getItem(STORAGE.visitor);
    if (id) return id;
    id = (globalThis.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : `visitor-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    try { localStorage.setItem(STORAGE.visitor, id); } catch (_) { /* no-op */ }
    return id;
  };

  const ballots = Array.isArray(window.GOAT_AUDIENCE_BALLOTS) ? window.GOAT_AUDIENCE_BALLOTS : [];
  if (!ballots.length) return;

  document.querySelectorAll('[data-goat-audience-archive]').forEach((root) => {
    const grid = root.querySelector('[data-audience-grid]');
    const search = root.querySelector('[data-audience-search]');
    const decade = root.querySelector('[data-audience-decade]');
    const sort = root.querySelector('[data-audience-sort]');
    const count = root.querySelector('[data-audience-count]');
    const resultCopy = root.querySelector('[data-audience-result-copy]');
    const more = root.querySelector('[data-audience-more]');
    const viewButtons = [...root.querySelectorAll('[data-audience-view]')];
    const modalShell = root.querySelector('[data-audience-modal]');
    const modalContent = root.querySelector('[data-audience-modal-content]');
    const toast = root.querySelector('[data-audience-toast]');
    const modeLabel = root.querySelector('[data-ballot-mode-label]');
    const modeCopy = root.querySelector('[data-ballot-mode-copy]');

    if (!grid || !modalShell || !modalContent) return;

    const endpoint = String(root.dataset.apiEndpoint || '').trim().replace(/\/$/, '');
    const shopUrl = root.dataset.shopUrl || '/search';
    const writeInsEnabled = root.dataset.writeIns !== 'false';
    const modalTitleId = root.dataset.modalTitleId || 'GOATAudienceModalTitle';
    const initialLimit = Math.max(6, Number(root.dataset.initialLimit || 12));
    const queryView = new URLSearchParams(location.search).get('audience');
    let view = ['compare', 'boys', 'girls'].includes(queryView)
      ? queryView
      : (['compare', 'boys', 'girls'].includes(root.dataset.defaultView) ? root.dataset.defaultView : 'compare');
    let visible = initialLimit;
    let currentBallot = null;
    let modalView = 'compare';
    let previousFocus = null;

    const visitorId = makeVisitorId();
    const votedChoices = readJSON(STORAGE.votes, {});
    const localWriteIns = readJSON(STORAGE.writeIns, {});
    const resultCache = {};

    const ballotKey = (year) => `toy:${year}`;
    const laneLabel = (lane) => lane === 'girls' ? 'Girls’ Picks' : 'Boys’ Picks';
    const laneIcon = (lane) => lane === 'girls' ? '✨' : '🚀';

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.hidden = false;
      clearTimeout(showToast.timer);
      showToast.timer = setTimeout(() => { toast.hidden = true; }, 3600);
    };

    if (modeLabel && modeCopy) {
      if (endpoint) {
        modeLabel.textContent = 'Live public voting';
        modeCopy.textContent = 'Shared totals, with no customer login required.';
      } else {
        modeLabel.textContent = 'Anonymous browser voting';
        modeCopy.textContent = 'Votes stay on this device until the public voting service is connected.';
      }
    }

    const decades = [...new Set(ballots.map((item) => item.decade))].sort();
    decades.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      decade?.appendChild(option);
    });

    const setView = (nextView, rerender = true) => {
      view = ['compare', 'boys', 'girls'].includes(nextView) ? nextView : 'compare';
      viewButtons.forEach((button) => {
        const active = button.dataset.audienceView === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      visible = initialLimit;
      if (rerender) renderGrid();
    };

    const lanePreview = (item, lane) => {
      const choices = item[lane] || [];
      const leader = choices[0];
      return `
        <button class="goat-audience-lane-preview goat-audience-lane-preview--${lane}" type="button" data-open-year="${item.year}" data-open-lane="${lane}">
          <span class="goat-audience-lane-kicker">${laneIcon(lane)} ${laneLabel(lane)}</span>
          <span class="goat-audience-lane-leader"><small>#1 editorial pick</small><strong>${escapeHTML(leader?.name || '')}</strong></span>
          <ol class="goat-audience-mini-list">
            ${choices.slice(1).map((choice) => `<li><span>${choice.rank}</span>${escapeHTML(choice.name)}</li>`).join('')}
          </ol>
          <span class="goat-audience-open">Open ${lane === 'boys' ? 'boys’' : 'girls’'} ballot →</span>
        </button>`;
    };

    const renderCard = (item) => {
      const lanes = view === 'compare' ? ['boys', 'girls'] : [view];
      return `
        <article class="goat-audience-year-card goat-audience-year-card--${view}">
          <header class="goat-audience-year-head">
            <div><span>GOAT ballot</span><h3>${item.year}</h3></div>
            <span class="goat-audience-confidence">${escapeHTML(item.confidence || 'Editorial')}</span>
          </header>
          <div class="goat-audience-year-lanes">
            ${lanes.map((lane) => lanePreview(item, lane)).join('')}
          </div>
          ${view === 'compare' ? `<button class="goat-audience-compare-button" type="button" data-open-year="${item.year}" data-open-lane="compare">Compare all 10 finalists →</button>` : ''}
        </article>`;
    };

    const filteredBallots = () => {
      const query = String(search?.value || '').trim().toLowerCase();
      const decadeValue = decade?.value || '';
      const sortValue = sort?.value || 'newest';
      const filtered = ballots.filter((item) => {
        const names = [...item.boys, ...item.girls].map((choice) => choice.name).join(' ');
        const haystack = `${item.year} ${names}`.toLowerCase();
        return (!query || haystack.includes(query)) && (!decadeValue || item.decade === decadeValue);
      });
      filtered.sort((a, b) => sortValue === 'oldest' ? a.year - b.year : b.year - a.year);
      return filtered;
    };

    const renderGrid = () => {
      const filtered = filteredBallots();
      const shown = filtered.slice(0, visible);
      grid.innerHTML = shown.length
        ? shown.map(renderCard).join('')
        : '<div class="goat-ballot-empty"><h3>No GOAT ballots found.</h3><p>Try a different toy, year, or decade.</p></div>';
      if (count) count.textContent = String(filtered.length);
      if (resultCopy) {
        resultCopy.textContent = view === 'compare'
          ? 'Compare five boys’ picks and five girls’ picks for every matching year.'
          : `Showing the five ${view === 'boys' ? 'boys’' : 'girls’'} picks for every matching year.`;
      }
      if (more) {
        more.hidden = visible >= filtered.length;
        more.textContent = visible < filtered.length ? `Show more years (${filtered.length - visible} remaining)` : 'All years shown';
      }
    };

    const normalizeResults = (payload, item) => {
      const votes = {};
      [...item.boys, ...item.girls].forEach((choice) => { votes[choice.id] = 0; });
      (Array.isArray(payload?.votes) ? payload.votes : []).forEach((row) => {
        votes[String(row.choice_id)] = Number(row.count || 0);
      });
      if (!endpoint) {
        Object.keys(votedChoices).forEach((choiceId) => {
          if (votedChoices[choiceId]) votes[choiceId] = Math.max(1, Number(votes[choiceId] || 0));
        });
      }
      return {
        mode: payload?.mode || (endpoint ? 'public' : 'local'),
        votes,
        suggestions: Array.isArray(payload?.suggestions) ? payload.suggestions : [],
        error: Boolean(payload?.error)
      };
    };

    const fetchResults = async (item) => {
      const key = ballotKey(item.year);
      if (!endpoint) {
        const local = normalizeResults({ mode: 'local' }, item);
        local.suggestions = localWriteIns[key] || [];
        resultCache[key] = local;
        return local;
      }
      try {
        const response = await fetch(`${endpoint}/api/results?category=toy&year=${item.year}`, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Public totals unavailable.');
        const payload = await response.json();
        resultCache[key] = normalizeResults(payload, item);
        return resultCache[key];
      } catch (_) {
        const fallback = normalizeResults({ mode: 'local', error: true }, item);
        fallback.suggestions = localWriteIns[key] || [];
        resultCache[key] = fallback;
        return fallback;
      }
    };

    const parseSuggestion = (suggestion) => {
      const rawReason = String(suggestion.reason || '');
      const match = rawReason.match(/^Audience:\s*(boys|girls)\s*\|\s*/i);
      const audience = suggestion.audience || (match ? match[1].toLowerCase() : 'boys');
      return {
        ...suggestion,
        audience: audience === 'girls' ? 'girls' : 'boys',
        cleanReason: match ? rawReason.replace(match[0], '') : rawReason,
        choice_id: String(suggestion.choice_id || suggestion.id || ''),
        choice_name: String(suggestion.choice_name || suggestion.name || 'Community choice')
      };
    };

    const choiceCard = (choice, item, results, community = false) => {
      const choiceId = String(choice.choice_id || choice.id);
      const choiceName = String(choice.choice_name || choice.name || 'Community choice');
      const total = Number(results.votes[choiceId] || 0);
      const voted = Boolean(votedChoices[choiceId]);
      const rank = community ? '＋' : choice.rank;
      const label = community ? 'Community write-in' : choice.editorial_label;
      const meta = community ? (choice.cleanReason || 'Submitted by the herd') : choice.origin;
      return `
        <article class="goat-choice${choice.rank === 1 && !community ? ' goat-choice--leader' : ''}${community ? ' goat-choice--community' : ''}">
          <div class="goat-choice-rank">${escapeHTML(rank)}</div>
          <div class="goat-choice-copy">
            <span>${escapeHTML(label)}</span>
            <h4>${escapeHTML(choiceName)}</h4>
            <p>${escapeHTML(meta || '')}</p>
          </div>
          <div class="goat-choice-actions">
            <button class="goat-choice-vote${voted ? ' is-voted' : ''}" type="button" data-vote-choice="${escapeHTML(choiceId)}" data-choice-name="${escapeHTML(choiceName)}" aria-pressed="${voted}">
              <span aria-hidden="true">▲</span><strong>${voted ? 'Voted' : 'Vote'}</strong><small>${total.toLocaleString()}</small>
            </button>
            <a class="goat-choice-shop" href="${escapeHTML(shopUrl)}?q=${encodeURIComponent(choiceName)}">Shop or find similar →</a>
          </div>
        </article>`;
    };

    const lanePanel = (item, lane, results, suggestions) => {
      const community = suggestions.filter((entry) => entry.audience === lane);
      return `
        <section class="goat-audience-lane-panel goat-audience-lane-panel--${lane}" data-modal-lane="${lane}">
          <header>
            <span>${laneIcon(lane)}</span>
            <div><small>${item.year} ballot</small><h3>${laneLabel(lane)}</h3></div>
          </header>
          <div class="goat-choice-grid">
            ${item[lane].map((choice) => choiceCard(choice, item, results, false)).join('')}
            ${community.map((choice) => choiceCard(choice, item, results, true)).join('')}
          </div>
        </section>`;
    };

    const sourceLinks = (item) => (item.sources || []).filter(Boolean).map((source, index) =>
      `<a href="${escapeHTML(source)}" target="_blank" rel="noopener noreferrer">Research source ${index + 1} ↗</a>`
    ).join('');

    const renderModal = (item, results, loading = false) => {
      const key = ballotKey(item.year);
      const combinedSuggestions = [...(results.suggestions || []), ...(endpoint ? [] : (localWriteIns[key] || []))]
        .map(parseSuggestion)
        .filter((entry, index, array) => array.findIndex((match) => match.choice_id === entry.choice_id) === index);
      const publicMode = endpoint && results.mode === 'public' && !results.error;
      const lanes = modalView === 'compare' ? ['boys', 'girls'] : [modalView];
      modalContent.innerHTML = `
        <div class="goat-ballot-modal-hero goat-audience-modal-hero">
          <div>
            <span>The ${item.year} GOAT Toys ballot</span>
            <h2 id="${escapeHTML(modalTitleId)}">Choose a list—or compare all ten.</h2>
            <p>Vote on every finalist you believe deserves a place. No Shopify customer account is needed.</p>
          </div>
          <div class="goat-ballot-modal-icon" aria-hidden="true">🐐</div>
        </div>
        <div class="goat-ballot-modal-body">
          <div class="goat-ballot-modal-status">
            <strong>${publicMode ? '● Live public totals' : '● Browser-only totals'}</strong>
            <span>${publicMode ? 'Votes are shared across visitors.' : 'Votes stay on this browser until the public voting service is connected.'}</span>
          </div>
          <div class="goat-modal-audience-switch" role="group" aria-label="Choose ballot list">
            <button type="button" data-modal-view="compare" class="${modalView === 'compare' ? 'is-active' : ''}" aria-pressed="${modalView === 'compare'}">⚖️ Compare Both</button>
            <button type="button" data-modal-view="boys" class="is-boys ${modalView === 'boys' ? 'is-active' : ''}" aria-pressed="${modalView === 'boys'}">🚀 Boys’ Picks</button>
            <button type="button" data-modal-view="girls" class="is-girls ${modalView === 'girls' ? 'is-active' : ''}" aria-pressed="${modalView === 'girls'}">✨ Girls’ Picks</button>
          </div>
          ${loading ? '<div class="goat-ballot-loading">Loading public vote totals…</div>' : ''}
          <div class="goat-audience-modal-lanes goat-audience-modal-lanes--${modalView}">
            ${lanes.map((lane) => lanePanel(item, lane, results, combinedSuggestions)).join('')}
          </div>
          ${writeInsEnabled ? `
            <div class="goat-write-in-panel goat-audience-write-in">
              <div class="goat-write-in-head">
                <div><h3>Did we miss one?</h3><p>Add a toy to either list. Public write-ins enter moderation before appearing to everyone.</p></div>
                <span aria-hidden="true">＋</span>
              </div>
              <form class="goat-write-in-form" data-write-in-form>
                <div class="goat-field">
                  <label for="GoatWriteInAudience-${item.year}">Add it to</label>
                  <select id="GoatWriteInAudience-${item.year}" name="audience" required>
                    <option value="boys">Boys’ Picks</option>
                    <option value="girls">Girls’ Picks</option>
                  </select>
                </div>
                <div class="goat-field"><label for="GoatWriteInName-${item.year}">Toy name</label><input id="GoatWriteInName-${item.year}" name="name" maxlength="80" required placeholder="Your missing GOAT"></div>
                <div class="goat-field"><label for="GoatWriteInReason-${item.year}">Why it belongs</label><input id="GoatWriteInReason-${item.year}" name="reason" maxlength="200" placeholder="Optional short reason"></div>
                <button class="goat-button goat-button--primary" type="submit">Submit choice</button>
              </form>
              <p class="goat-write-in-note">Do not submit a child’s name, contact information, links, or other personal details.</p>
            </div>` : ''}
          ${results.error ? '<div class="goat-ballot-error">The public voting service could not be reached. Your interaction will remain local for now.</div>' : ''}
          <details class="goat-ballot-research">
            <summary>How this annual ballot was built</summary>
            <p>${escapeHTML(item.basis || '')}</p>
            <div>${sourceLinks(item)}</div>
            <p>The audience labels are shopping and browsing lanes—not limits on which children can enjoy a toy.</p>
          </details>
        </div>`;
    };

    const openModal = async (item, requestedLane = 'compare') => {
      currentBallot = item;
      modalView = ['compare', 'boys', 'girls'].includes(requestedLane) ? requestedLane : 'compare';
      previousFocus = document.activeElement;
      const initial = normalizeResults({ mode: endpoint ? 'public' : 'local' }, item);
      initial.suggestions = localWriteIns[ballotKey(item.year)] || [];
      renderModal(item, initial, Boolean(endpoint));
      modalShell.hidden = false;
      document.body.classList.add('goat-modal-open');
      modalShell.querySelector('[data-audience-close]')?.focus();
      const loaded = await fetchResults(item);
      if (currentBallot === item) renderModal(item, loaded, false);
    };

    const closeModal = () => {
      modalShell.hidden = true;
      document.body.classList.remove('goat-modal-open');
      currentBallot = null;
      previousFocus?.focus?.();
    };

    const postVote = async (choiceId, choiceName) => {
      if (!currentBallot) return;
      votedChoices[choiceId] = true;
      writeJSON(STORAGE.votes, votedChoices);
      const key = ballotKey(currentBallot.year);
      const existing = resultCache[key] || normalizeResults({ mode: endpoint ? 'public' : 'local' }, currentBallot);
      existing.votes[choiceId] = Math.max(1, Number(existing.votes[choiceId] || 0) + (endpoint ? 0 : 1));
      resultCache[key] = existing;
      renderModal(currentBallot, existing, false);

      if (!endpoint) {
        showToast('Vote saved on this device. Connect the public voting service for shared totals.');
        return;
      }
      try {
        const response = await fetch(`${endpoint}/api/vote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ category: 'toy', year: currentBallot.year, choice_id: choiceId, choice_name: choiceName, visitor_id: visitorId })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'Vote was not accepted.');
        const normalized = normalizeResults(payload.results || payload, currentBallot);
        resultCache[key] = normalized;
        renderModal(currentBallot, normalized, false);
        showToast(payload.already_voted ? 'You already voted for this toy.' : 'Your vote is live.');
      } catch (_) {
        showToast('The public service is unavailable. Your vote is saved on this device.');
      }
    };

    const submitWriteIn = async (form) => {
      if (!currentBallot) return;
      const data = new FormData(form);
      const audience = data.get('audience') === 'girls' ? 'girls' : 'boys';
      const name = String(data.get('name') || '').trim();
      const reason = String(data.get('reason') || '').trim();
      if (name.length < 2) return;
      const key = ballotKey(currentBallot.year);

      if (!endpoint) {
        const id = `toy-${currentBallot.year}-community-${audience}-${slugify(name)}-${Date.now()}`;
        const entry = { id, choice_id: id, name, choice_name: name, reason, audience };
        localWriteIns[key] = [...(localWriteIns[key] || []), entry];
        writeJSON(STORAGE.writeIns, localWriteIns);
        const local = resultCache[key] || normalizeResults({ mode: 'local' }, currentBallot);
        local.suggestions = localWriteIns[key];
        resultCache[key] = local;
        renderModal(currentBallot, local, false);
        showToast('Your write-in was added on this device.');
        return;
      }

      try {
        const response = await fetch(`${endpoint}/api/suggest`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            category: 'toy',
            year: currentBallot.year,
            name,
            reason: `Audience: ${audience} | ${reason}`,
            visitor_id: visitorId
          })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.error || 'Submission was not accepted.');
        form.reset();
        showToast(payload.duplicate ? 'That write-in is already under review.' : 'Submitted for moderation.');
      } catch (error) {
        showToast(error.message || 'The write-in could not be submitted.');
      }
    };

    root.addEventListener('click', (event) => {
      const viewButton = event.target.closest('[data-audience-view]');
      if (viewButton) {
        setView(viewButton.dataset.audienceView);
        return;
      }

      const openButton = event.target.closest('[data-open-year]');
      if (openButton) {
        const item = ballots.find((ballot) => ballot.year === Number(openButton.dataset.openYear));
        if (item) openModal(item, openButton.dataset.openLane || 'compare');
        return;
      }

      if (event.target.closest('[data-audience-close]')) {
        closeModal();
        return;
      }

      const modalViewButton = event.target.closest('[data-modal-view]');
      if (modalViewButton && currentBallot) {
        modalView = modalViewButton.dataset.modalView;
        const results = resultCache[ballotKey(currentBallot.year)] || normalizeResults({ mode: endpoint ? 'public' : 'local' }, currentBallot);
        renderModal(currentBallot, results, false);
        return;
      }

      const voteButton = event.target.closest('[data-vote-choice]');
      if (voteButton && currentBallot) {
        if (votedChoices[voteButton.dataset.voteChoice]) {
          showToast('You already voted for this toy.');
          return;
        }
        postVote(voteButton.dataset.voteChoice, voteButton.dataset.choiceName || 'Toy');
      }
    });

    root.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-write-in-form]');
      if (!form) return;
      event.preventDefault();
      submitWriteIn(form);
    });

    [search, decade, sort].filter(Boolean).forEach((control) => {
      control.addEventListener(control === search ? 'input' : 'change', () => {
        visible = initialLimit;
        renderGrid();
      });
    });

    more?.addEventListener('click', () => {
      visible += initialLimit;
      renderGrid();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modalShell.hidden) closeModal();
    });

    setView(view, false);
    renderGrid();
  });
})();
